import React, { Component } from 'react';
import PropTypes from "prop-types";
import {BeatLoader} from 'react-spinners';
import Modal from 'react-modal';
import {get, postResponse, postWithHeadersResponse} from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import {_addNotificationError, _addNotification} from "../../../server/util";
import $ from 'jquery';
import Slider from "react-slick";
import { getLoginDistrictInfo } from '../../../server/utilDistrict';

//const optionalFields=['SSID', 'Cert Date', 'Code', 'Last'];

const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
class DistrictCertificationSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            invalidStudentIds:[],
            responseMessage:'',
            mapFields:[],
            mainFields:[],
            uploadedFile: null,
            userInfo: getLoginDistrictInfo(),
        }
        this.getDistrictDirectCertificationFieldMap=this.getDistrictDirectCertificationFieldMap.bind(this);
    }

    componentDidMount = () => {
       this.getDistrictDirectCertificationFieldMap();
       this._notificationSystem = this.refs.notificationSystem;
    }

     handleForce=(e)=>{
        const file = e.target.files[0];
            this.setState({uploadedFile: file});
    }

    onOptionChange=(e)=>{
       let controlIndex= e.target.getAttribute('data-rid');
       let mainFieldList= this.state.mainFields;
       mainFieldList[parseInt(controlIndex)].mapField=e.target.value;       
       this.setState({mainFields:mainFieldList});
    }

    getDistrictDirectCertificationFieldMap=()=>{
            const { userInfo } = this.state;
            const districtID = userInfo.districtId;
            this.setState({loading: true});
            get('/directCertFieldMapping?districtId=' + districtID + '&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                console.log('data', data);
                let _mainFields = [];
                let _mapFields=[];
                let notMapFieldCount=0
               Object.keys(data).forEach(fieldkey=>{
                if (fieldkey !== 'StudentName') {
                    _mainFields.push({reqField:fieldkey, mapField:data[fieldkey]});
                }
                if(data[fieldkey].trim()!='')
                    _mapFields.push(data[fieldkey].trim())
                else
                    notMapFieldCount=notMapFieldCount+1;
                });
                if( Object.keys(data).length===notMapFieldCount)
                    this.slider.slickGoTo(0);
                else
                    this.slider.slickGoTo(1);
    
                this.setState({mainFields:_mainFields, loading:false});
                this.setState({mapFields:_mapFields});
            }).catch(
                (error) => {   
                    this.setState({loading: false})             
                    console.log('Get District data response', error)
                }
            );
        }
    onSaveSubmit=()=>{
                const { userInfo } = this.state;
                const districtID = userInfo.districtId;
                this.setState({loading: true})       
                let isValid=true;
                if(isValid){
                    let mainList={}
                    this.state.mainFields.forEach(field=>{
                        mainList[field.reqField]=field.mapField;
                    })
                    let headers = {
                        'Content-Type': 'application/json'
                    };
                    postWithHeadersResponse('/directCertFieldMapping?districtId=' + districtID + '&access_token=', JSON.stringify(mainList),headers).then((response) => {
                        if (response.statusCode!==200) {               
                            throw Error(response.statusMessage);
                        }
                        console.log('response', response);
                        return response;
                    }).then(res => {
                        this.setState({loading: false})
                        _addNotification(res.statusMessage, this);
                        return true;
                    }).catch(
                        (error) => {
                            this.setState({loading: false})
                             _addNotificationError(error.message,this);  
                             return false;             
                        }
                    )
                }else{
                    this.setState({loading: false})
                    _addNotificationError('Please map all the mandatory fields.',this);
                    return false;
                }
            }

handleSubmit = (e) => {
    e.preventDefault();
    if (!this.state.uploadedFile) {
        _addNotificationError('Please select a file to upload.', this);
        return;
    }
    const data = new FormData();
    data.append('file', this.state.uploadedFile);
    this.setState({ loading: true });

    postResponse('/directCertFileColumns?access_token=', data)
        .then((response) => {        
            return response;
        })
        .then((res) => {
            // ✅ GET HEADERS FROM API RESPONSE
            const columns = res.columns || [];

            if (!Array.isArray(columns) || columns.length === 0) {
                throw new Error('No columns found in uploaded file.');
            }

            // ✅ Save headers for mapping dropdown
            this.setState({
                mapFields: columns,
                loading: false
            }, () => {

                // 👉 Move to mapping slide AFTER state update
                this.slider.slickGoTo(1);
            });

            _addNotification('File processed successfully. Please map fields.', this);
        })
        .catch((error) => {
            this.setState({ loading: false });
            _addNotificationError(error.message, this);
        });
   };

    render() {
         let settings = {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: true,
            adaptiveHeight: true,
            schoolName:''
        
        };

    let allOptions = [...new Set([ ...(this.state.mapFields || [])])];
        return (
            <section className="full-width clearfix">
                <div className="container">
                    <NotificationSystem ref="notificationSystem"/>
                    <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="sectionTitle">
                                <h2>
                                    <span></span>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="row">
                        <form onSubmit={(e) => this.handleSubmit(e)}>
                            <div className="col-md-12 col-sm-12 col-xs-12 text-center createmenu-panel">
                                <div className="panel panel-primary">
                                    <div className="panel-heading text-center">
                                        <h3 className="panel-title"> {'Direct Certification Settings'}</h3>
                                    </div>
                                    <Slider  ref={slider => (this.slider = slider)} {...settings}>
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-center">
                                                    <label className="control-label"> Import Direct Certification Data </label>
                                                </div>        
                                                 <div className="uploadFileInfo col-md-12 col-sm-12 col-xs-12 createmenu-file-group">
                                                    <div className="input-group col-md-7 col-md-offset-3 col-sm-12 col-xs-12">
                                                        <input type="file" className="form-control"
                                                                            style={{opacity: '1', zIndex: '0'}}
                                                                            id="mealFile" aria-describedby="basic-addon21"
                                                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                                            onChange={this.handleForce}
                                                                            />
                                                                        <button id="OpenUpload"
                                                                                className="input-group-addon" onClick={() => {
                                                                            $('#mealFile').click()
                                                                        }}><i
                                                                            className="fa fa-upload"
                                                                            aria-hidden="true"/>
                                                                        </button>
                                                                    </div>
                                                
                                                                </div>
                                                                <div className="col-md-12 col-sm-12 col-xs-12 createmenu-link-group">
                                                                    <p className="input-group col-md-12 col-sm-12 col-xs-12">Upload student Certification data. Download&nbsp;<a
                                                                        href="https://mealmanage-prod.s3.amazonaws.com/SampleFiles/CertificationDateImport.xlsx"
                                                                        download>Sample file</a>
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-7 col-md-offset-3 text-center">
                                                                    <button type="submit" id="submit" className="btn btn-sm btn-primary" onClick={this.handleSubmit}><i
                                                                        className="fa fa-arrow-circle-right"></i>
                                                                        <span>Proceed</span></button>
                                                                </div>                        
                                                            </div>                    
                                                        </div>
                                                    </div>
                     <div className="col-md-12">
                        <form name="frmSetMap" ref={c => { this.form = c }} className=""  >
                         <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                            <div className='row'>
                            <div className="col-md-5"><b>Destination Fields</b></div>
                            <div className="col-md-7"><b>Source Fields</b></div>
                            </div>
                            </li>
                           {this.state.mainFields.map((field,key)=>{
                           return( <li style={{padding: '3px', border: '1px solid #ddd'}}>
                            <div className='row'>
                              <div className="col-md-5">{field.reqField}</div>
                                <div className="col-md-7">
                                    <select name={'select-'+key} class="form-control" data-rid={key} data-fname={field.reqField}  value={field.mapField} 
                                    onChange={this.onOptionChange} ><option value=''> Select </option>{allOptions.map((item) => (
                                        <option value={item}>{item}</option>
                                    ))}</select>
                                </div>
                               </div>
                        </li>)   ;
                      })}
                    </ul>    
                  </form>
                <div class="col-md-12">
                  <input type="button" value="Save" className="btn btn-sm btn-primary" onClick={this.onSaveSubmit} />
                 </div>         
             </div>
         </Slider>
            </div>
        </div>
    </form>
  </div>
 </div>
</div>  
<Modal isOpen={this.state.alertModalIsOpen} style={modalStyles} >            
    <div className="modal-body">
        <div className="row">
            {
                this.state.invalidStudentIds.length<=0?
                <div className="col-md-12 col-sm-12">
                    <p className="color-5 text-center" style={{
                                fontSize: '13px',
                                fontWeight: '600'
                        }}>
                        <strong>{this.state.responseMessage}</strong>
                        </p>
                </div> :
                <div className="col-md-12 col-sm-12">
                    <div className="row">
                        <div className="col-md-12">
                            <p className="color-5 text-center" style={{
                                fontSize: '13px',
                                fontWeight: '600'
                            }}>
                            <strong>
                                {
                                    this.state.responseMessage
                                }
                            </strong>
                            </p>
                            <p className="color-1" style={{
                                fontSize: '13px',
                                fontWeight: '600'
                            }}> <strong>Note:</strong> These below student id's does not exists in MealManage. Please check and make sure that you are passing valid students.</p>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <span style={{color:'red', textDecoration:'underline'}} >Invalid Student Id's:</span> <span className="pull-right">Count:{this.state.invalidStudentIds.length}</span>
                            <div className="row" style={{overflowY:'scroll', height:'200px'}}>
                            { this.state.invalidStudentIds.length>0?
                                this.state.invalidStudentIds.map(item=>{
                                    return (<div className="col-md-4"><i className="fa fa-hand-o-right"></i> { item}</div>)
                                }):<div className="col-md-12">No records found</div>
                            }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
    <div className="modal-footer">
        <div className="text-right">
            <button type="button" className="btn btn-success btn-xs"
                    style={{ margin: '0 0 0 5px' }} onClick={()=>{
                        this.setState({alertModalIsOpen:false},
                            this.context.router.history.push('/schoolAdmin/manageSchool')
                        )
                    }}
                    id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
            </button>
        </div>
    </div>
</Modal>              
</section>
        );
    }
}
DistrictCertificationSettings.contextTypes = {
    router: PropTypes.object.isRequired
}

export default DistrictCertificationSettings;



// WEBPACK FOOTER //
// ./src/components/District/districtDirectCertificationSettings/index.js